import React from 'react'
import { makeStyles } from '@material-ui/core'
import { BASE_COLORS } from 'asterX-UI/colors.constant'
import { COLOR_VARIANTS } from 'asterX-UI/theme.constant'
import PropTypes from 'prop-types'

const getColor = (color, theme, val = 600) => {
  const [primary, secondary, info, warning, error, success] = COLOR_VARIANTS
  if (color === primary) {
    return theme.palette.allPrimary[val]
  }
  if (color === info) {
    return theme.palette.allInfo[val]
  }
  if (color === warning) {
    return theme.palette.allWarning[val]
  }
  if (color === error || color === secondary) {
    return theme.palette.allError[val]
  }
  if (color === success) {
    return theme.palette.allSuccess[val]
  }
  return BASE_COLORS.White
}

export const useStyles = makeStyles(theme => ({
  innerCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    borderStyle: 'solid',
    border: 8,
    padding: 3,
    borderColor: props => {
      const { color } = props
      return getColor(color, theme, 50)
    },
    color: props => {
      const { color } = props
      return getColor(color, theme)
    },
    backgroundColor: props => {
      const { color } = props
      return getColor(color, theme, 200)
    }
  }
}))

export const FutureIconContainer = ({ color, ...props }) => {
  const classes = useStyles({ color })
  return <div className={classes.innerCircle}>{props.children}</div>
}

FutureIconContainer.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary', 'info', 'warning', 'error', 'success']),
  children: PropTypes.node
}
